import Reveal from '@/pages/zz-review/components/Reveal';

const tiers = [
  {
    code: 'A',
    name: '個人單本實踐版',
    price: 'NT$580',
    featured: false,
    items: [
      '《1001旋轉門》紙本書 1 冊',
      'RG Portal 實踐起點導航卡 1 份',
      '3 次 AI Angel 中軸導航與 Evidence 建立體驗',
      '臺灣本島及離島單一地址配送',
    ],
    note: '',
  },
  {
    code: 'B',
    name: '雙書同行版',
    price: 'NT$1,080',
    featured: false,
    items: [
      '《1001旋轉門》紙本書 2 冊',
      'RG Portal 實踐起點導航卡 2 份',
      '專屬中軸書籤 2 份',
      '臺灣本島及離島單一地址配送',
    ],
    note: '適合一本自修、一本贈予重要的同行者。',
  },
  {
    code: 'C',
    name: '組織共讀啟動組',
    price: 'NT$5,080',
    featured: true,
    items: [
      '《1001旋轉門》紙本書 10 冊',
      '企業／團隊 90 日 RG 實踐入口指南 10 份',
      '企業實踐說明與後續專案諮詢登記資格',
      '臺灣本島單一地址配送',
    ],
    note: '本方案不含工作坊、顧問服務或客製導入；若有需求，將另行評估與報價。',
  },
];

export default function RewardsSection() {
  return (
    <section id="rewards" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-6">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              募資回饋方案
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              三種方式，支持這本書
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
              本書紙本定價為 NT$580。首發募資不以大幅折價作為動機，而是提供臺灣配送與書籍驅動的實踐入口。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-10">
          {tiers.map((t, i) => (
            <Reveal key={t.code} delay={i * 80}>
              <div
                className={`h-full rounded-lg border p-6 md:p-7 flex flex-col ${
                  t.featured
                    ? 'border-primary-300/70 bg-primary-50'
                    : 'border-background-200/70 bg-background-50'
                }`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <span
                    className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-medium ${
                      t.featured
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-700 border border-background-200/70'
                    }`}
                  >
                    {t.code}
                  </span>
                  <h3
                    className="text-lg md:text-xl text-foreground-900"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {t.name}
                  </h3>
                </div>

                <p className="text-2xl md:text-3xl text-foreground-900 font-semibold mb-6">{t.price}</p>

                <ul className="space-y-3 mb-6 flex-1">
                  {t.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-700 mt-0.5 shrink-0" />
                      <span className="leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>

                {t.note && (
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed border-t border-background-200/70 pt-4">
                    {t.note}
                  </p>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="text-center text-xs md:text-sm text-foreground-500 leading-relaxed max-w-3xl mx-auto mt-8">
            港澳及其他海外地區將依實際配送地區加收運費，以系統結帳時顯示的附加運費為準。進口關稅、當地稅費或偏遠地區附加費，如有發生，由贊助者負擔。
          </p>
        </Reveal>
      </div>
    </section>
  );
}